module.exports = __webpack_public_path__ + "images/frontpage_undo@3x.png?6def7cb6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_undo@3x.png
// module id = 668
// module chunks = 7